export const PERMS = {
    READ: 'report_driver_performance_analysis.read',
    EXPORT: 'report_driver_performance_analysis.export',
}
